import {openPopupById, closeAllPopups, getQueryParamFromUrl, checkIfAuthPopup} from "../../utils/togglePopup";

const handleTogglePopup = () => {
    document.querySelectorAll('[data-open-popup]').forEach((button) => {
        const popupId = button.dataset.openPopup;
        const product = button.dataset.product;
        button.addEventListener('click', () => {
            closeAllPopups();
            openPopupById(popupId, product);
        });
    });
    
    document.querySelectorAll('[data-close-popup]').forEach((closeButton) => {
        closeButton.addEventListener('click', (e) => {
            e.stopPropagation();
            if ((e.target === e.currentTarget) || (
                e.target.tagName.toLowerCase() === 'img' &&
                e.currentTarget.tagName.toLowerCase() === 'button'
            )) {
                closeAllPopups();
            }
        });
    });

    const modalFromUrl = getQueryParamFromUrl('modal');
    if (modalFromUrl && checkIfAuthPopup(modalFromUrl)) {
        openPopupById(modalFromUrl);
    }
};

handleTogglePopup();
